export const TRAMPAS = 1;
export const PLANTAS = 2;
